import React from 'react';
import { RangeSlider } from '../RangeFilters';
import { ActiveCarot } from './ActiveCarot';
import { AccordionButton, DrawerSubTitle } from './ListAccordion';
import { AccordionContentWrapper } from './ListAccordion';

export const RangeAccordion = ({
  filters,
  accordionProps,
  startingIdx = 0
}) => {
  const rangeFilters = filters.filter(
    filter => filter.__typename === 'NumericRangeFilter'
  );
  if (rangeFilters.length === 0) return null;

  return rangeFilters.map((rangeFilter, idx) => (
    <RangeFilter
      key={rangeFilter.id}
      rangeFilter={rangeFilter}
      idx={idx}
      accordionProps={accordionProps}
      startingIdx={startingIdx}
    ></RangeFilter>
  ));
};

function RangeFilter({ rangeFilter, idx, accordionProps, startingIdx }) {
  const accordionIsOpen = accordionProps.openIndexes.includes(
    idx + startingIdx
  );
  const { AccordionContent } = accordionProps;

  return (
    <React.Fragment>
      <AccordionButton
        onClick={() => accordionProps.handleClick(idx + startingIdx)}
      >
        <DrawerSubTitle>
          {rangeFilter.name}
          {rangeFilter.isActive && <span className="count">(1)</span>}
        </DrawerSubTitle>
        <ActiveCarot isActive={rangeFilter.isActive} isOpen={accordionIsOpen} />
      </AccordionButton>
      <AccordionContent isOpen={accordionIsOpen}>
        <AccordionContentWrapper>
          <RangeSlider filter={rangeFilter} />
        </AccordionContentWrapper>
      </AccordionContent>
    </React.Fragment>
  );
}
